import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navyDeep text-mutedDark" data-id="element-88" data-mp="3gf96t1ka0gbl">
      <div className="tick-bar h-3 w-full" aria-hidden="true" data-id="element-89" data-mp="3ggtzeln15p6t" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32oe1fz8zkhcr">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-91" data-mp="32m1d94cmxar9">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="36n3chl6jxmt8">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-steel pt-6 text-xs" data-id="element-93" data-mp="3ucxsgbm63rhp">
          © 2026 {productName} — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}